import '../../styles/styles.css';
import React, { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';

import StoryblokService from '../../lib/storyblok-service';
import { pageRevalidationTime } from '../../config/general'
import getFeaturedProjects from '../../lib/getFeaturedProjects'

import Layout from '../../components/Layout';
import AnimateIn from '../../components/AnimateIn';
import LinkList from '../../components/LinkList';

const Blobs = dynamic(import('../../components/blobs/Blobs'));

const Careers = ({ featuredProjectsList, careers }) => {
  const { job_listing: jobListing } = careers.content;
  const [links, setLinks] = useState([])

  useEffect(() => {
    setLinks(jobListing.map(job => ({
      title: job.title,
      url: job.link.url,
      source: job.location
    })))
  }, [jobListing]);

  return (
    <Layout
      metaData={{ data: { title: 'Careers' } }}
      featuredProjectsList={featuredProjectsList}
    >
      {<Blobs />}

      <section className="components page">
        <AnimateIn className="text g-row">
          <div className="mb-50">Careers</div>
          <h1 className="mb-200">Every day, is a day spent with friends.</h1>
          <p>We’re a small team, so everyone here has a huge impact.</p>
          <p>
            Your Majesty is a collective of pioneering makers from uniquely
            different backgrounds, united in the pursuit of creating the future
            of digital experiences.
          </p>
        </AnimateIn>

        <AnimateIn className="text g-row">
          <h2>We’re here to</h2>
          <ul>
            <li>Transform brands and the people they touch.</li>
            <li>Have a positive effect on the world around us.</li>
            <li>Inspire and advance our people, clients and industry.</li>
            <li>Create our life’s work and workplace.</li>
            <li>Always learn and evolve.</li>
          </ul>
        </AnimateIn>

        <AnimateIn className="text g-row">
          <p>
            As a company, our principles and values have roots in the Swedish
            school of Hyper Island, where leadership, lifelong learning,
            transparency, group dynamics, collaboration (and kindness) create
            the pillars for our people and relationships.
          </p>
          <p>
            These principles deeply inform the way we design experiences
            end-to-end: from strategy through delivery and into the future.
          </p>
        </AnimateIn>
        <LinkList
          component={{
            title: 'Open roles',
            useLinksDirectly: true,
            links: links
          }}
        />
      </section>
    </Layout>
  );
};


export async function getStaticProps (ctx) {
  const featuredProjectsList = await getFeaturedProjects()

  let { preview } = ctx;

  preview = preview || process.env.NODE_ENV !== 'production';

  const res = await StoryblokService.get(
    `cdn/stories/careers`,
    {
      version: preview ? 'draft' : 'published',
    }
  );

  const careers = res.data.story

  return {
    props: { featuredProjectsList, careers },
    revalidate: pageRevalidationTime
  }
}

export default Careers;
